"use client";

import {
  Card,
  CardContent,
  Box,
  Typography,
  IconButton,
  Avatar,
  Chip,
} from "@mui/material";
import { Description, Visibility, Download, Delete } from "@mui/icons-material";
import moment from "moment";

export default function DocumentCard({
  document,
  onView,
  onDownload,
  onDelete,
  showCategory = true,
}) {
  const handleView = (e) => {
    e.stopPropagation();
    onView?.(document);
  };
  const handleDownload = (e) => {
    e.stopPropagation();
    onDownload?.(document);
  };
  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete?.(document);
  };

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Avatar sx={{ bgcolor: "primary.main" }}>
              <Description />
            </Avatar>
            <Box>
              <Typography variant="subtitle2">{document.nombre}</Typography>
              <Typography variant="caption" color="text.secondary">
                {moment(document.created_at).format("DD/MM/YYYY")}
              </Typography>
              {showCategory && document.tipo && (
                <Box sx={{ mt: 0.5 }}>
                  <Chip label={document.tipo} size="small" variant="outlined" />
                </Box>
              )}
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <IconButton size="small" onClick={handleView} title="Ver documento">
              <Visibility />
            </IconButton>
            <IconButton size="small" onClick={handleDownload} title="Descargar">
              <Download />
            </IconButton>
            <IconButton
              size="small"
              color="error"
              onClick={handleDelete}
              title="Eliminar"
            >
              <Delete />
            </IconButton>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
